import { render, staticRenderFns } from "./spreadView.vue?vue&type=template&id=21c3411f&"
import script from "./spreadView.vue?vue&type=script&lang=js&"
export * from "./spreadView.vue?vue&type=script&lang=js&"
import style0 from "./spreadView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports